/** @typedef {Object} DomainTypeData
 *  @property {string} domainId
 *  @property {string} domainName
 *  @property {['wrapper_domain', 'adapter_domain']?} domainType
*/

const ACTIONS = {
    'REGISTER_DOMAIN_MAPPINGS': 'REGISTER_DOMAIN_MAPPINGS'
}

/**
 * 
 * @param {Object} state 
 * @param {Object} actionObject
 * @param {string} actionObject.type
 * @param {Object<string, DomainTypeData[]>} actionObject.data
 * @returns 
 */
function domainTypesReducer(state = {}, { type, data }) {

    switch (type) {
        case ACTIONS.REGISTER_DOMAIN_MAPPINGS:
            return { ...state, ...data }
        default:
            return state
    }
}

/**
 * 
 * @param {Object<string, DomainTypeData[]>} data 
 */
function setDomainTypesMappings(data) {
    return {
        type: ACTIONS.REGISTER_DOMAIN_MAPPINGS,
        data
    }
}

export {
    setDomainTypesMappings
}

export default domainTypesReducer
